import React, { useState } from "react";
import CardContenido from "./CardContenido";
import arrow_up from "../../../../assets/vw/svg/arrow-up.svg";
import arrow_down from "../../../../assets/vw/svg/arrow-down.svg";

const SelectCard = ({
    infoCard,
    editar = () => { },
    handleArchivar = () => { },
    rowDesarchivar = () => { },
    index,
    selectCheck,
    archivo = false,
    aplicaciones,
    currentActive,
    setCurrentActive
}) => {

    const [showContent, setShowContent] = useState(false);

    const getApp = (idApp) => {
        const objApp = aplicaciones.find((app) => app.idApp === idApp);
        return objApp.nombre;
    };

    return (
        <div className={"select-card-container"}>
            <div className={"select-card-header d-flex justify-content-between"}>
                <div className={"d-flex"}>
                    <div className="ms-auto align-self-center">
                        <input
                            type="checkbox"
                            className="checkbox-round"
                            id={"select-" + index}
                            value={infoCard.original.idNotificacion}
                            onChange={(e) => selectCheck(e, index)}
                        />
                    </div>
                    <div className={"ml-3"}>
                        <div className="select-card-title-one-word font-weight-bolder">
                            {infoCard.original.accion}
                        </div>
                        <span className={"font-azul-claro-secundario"} style={{ fontSize: '12px' }}>
                            {getApp(infoCard.original.idAplicacion).length > 23
                                ? `${getApp(infoCard.original.idAplicacion).substring(0, 20)}…`
                                : getApp(infoCard.original.idAplicacion)}
                        </span>
                    </div>
                </div>
                <div className={"align-self-center"}>
                    <button
                        className={"button_icon-vw select-card-arrow"}
                        onClick={() => {
                            setShowContent(prevState => !prevState);
                            setCurrentActive({ id: index });
                        }}
                    >
                        {
                            (showContent && (currentActive.id !== null && (currentActive.id === index))) ? (
                                <img
                                    src={arrow_up}
                                    alt="arrow-up"
                                />
                            ) : (
                                <img
                                    src={arrow_down}
                                    alt="arrow-down"
                                />
                            )
                        }
                    </button>
                </div>

            </div>
            {
                (showContent && (currentActive.id !== null && (currentActive.id === index))) && (
                    <CardContenido
                        infoCard={infoCard}
                        handleArchivar={handleArchivar}
                        editar={editar}
                        archivo={archivo}
                        rowDesarchivar={rowDesarchivar}
                        id={index}
                        setShowContent={setShowContent}
                        getApp={getApp}
                    />
                )
            }
        </div>
    );
}

export default SelectCard;